export enum ExpenseTypes {
  Mileage = 1,
  Other = 2,
}

export class ExpenseType {
  id: number
  name: string
  
  constructor() {
  }

  static buildOne(obj: any): ExpenseType {
    let target: ExpenseType = Object.assign(new ExpenseType(), obj)
    return target
  }

  static buildMany(objs: any[]): ExpenseType[] {
    const lobjs = []
    for (const i in objs) {
      if (objs.hasOwnProperty(i)) {
        lobjs.push(ExpenseType.buildOne(objs[i]))
      }
    }
    return lobjs
  }
}

